import '@mantine/core/styles.css';
import './brand.css';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { portalTheme } from './theme';
import { AppRouter } from './router';

dayjs.extend(utc);
dayjs.extend(timezone);

createRoot(document.getElementById('root')!).render(
  <MantineProvider theme={portalTheme} defaultColorScheme="light">
    <AppRouter />
  </MantineProvider>,
);
